import { signInWithGoogle } from "./firebase";
import React, { useEffect, useState } from "react";
import firebase from "./firebase";

export const UserLogin = () => {
  const [user, setUser] = useState();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        setLoaded(true);
      }
      setUser(user);
      // console.log(user.uid);
      setLoaded(true);
    });
  }, []);

  const signOut = () => {
    firebase.auth().signOut();
  };

  if (!loaded) {
    return <div></div>;
  }

  return (
    <div>
      {user ? (
        <button
          onClick={signOut}
          className="block w-full px-12 py-3 text-sm font-medium text-white rounded shadow bg-gray-500 sm:w-auto focus:outline-none focus:ring"
        >
          Log Out
        </button>
      ) : (
        <button
          className="block w-full px-12 py-3 text-sm font-medium text-white rounded shadow bg-yellow-600 sm:w-auto active:bg-yellow-500 hover:bg-yellow-700 focus:outline-none focus:ring"
          onClick={signInWithGoogle}
        >
          Sign In
        </button>
      )}
    </div>
  );
};
